import { useState, useEffect, useContext } from 'react';
import {secured} from "../../../axios";
import {FaqContext} from '../state/faqContext';


export const useFAQ = () => {
  const [loading, setLoading] = useState(true);
    const {state, dispatch} = useContext(FaqContext);

  const mappedFaqs = (faqResponse) => {
    return  faqResponse.map(faq => {
        return {
            id : faq.id,
            question: faq.question.text,
            response: faq.response.text
        };
    });
  }

    const getFaqById = async (id) => {
      setLoading(true);
        let res = [];
        if (state.length === 0) {
            await secured.get('/faqs')
                .then(response => {
                    console.log('response', response)
                    const mapped = mappedFaqs(response.data)
                    dispatch({type: 'initFaq', payload: mapped});
                    res = mapped.find(faq => faq.id == id);
                })
                .catch(error => {
                    console.error('Error fetching FAQs:', error);
                });
        } else {
            res = state.find(faq => faq.id == id);
        }
        setLoading(false);
        return res;
    }

  useEffect(() => {
      secured.get('/faqs')
      .then(response => {
        dispatch({type: 'initFaq', payload: mappedFaqs(response.data)});
        setLoading(false);
      })
      .catch(() => setLoading(false));
      setLoading(false)
  }, []);

  return { faqs : state ?? [], loading, getFaqById };
};